// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookSelect__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BookSelect/BookSelect.scss
 ** module id = 892
 ** module chunks = 1
 **/